export default __webpack_public_path__ + "static/ctu_logo-ae6588796f28b5c6fb8c493efe7e2319.svg";